<div class="pages-wrap">
    <pages-top></pages-top>
    <div class="pages-body">
        <sidebar></sidebar>
        <div class="pages-content">
            <router-outlet></router-outlet>
        </div>
        <right-config></right-config>
    </div>



    <footer class="footer">
        Cooperando somos m&aacute;s fuertes
    </footer>
</div>


// WEBPACK FOOTER //
// ./src/app/pages/pages.component.html